import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Menu, MenuItem } from '@blueprintjs/core'

const BPMenuMobile = ({ items, onMobileMenuClick }) => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <div>
      {Array.isArray(items)
        ? items.map((item, index) => (
            <React.Fragment key={`${item.name}${index}`}>
              <Menu className='nvmenu' large>
                {item.items && item.items.length > 0 ? (
                  <MenuItem
                    key={`${item.name}${index}`}
                    icon={<i className={`fas ${item.icon} text-white`} />}
                    text={t(item.name)}
                    // popoverProps={{ isOpen: true }}
                  >
                    {item.items.map((subItem, subItemIndex) => (
                      <MenuItem
                        key={subItemIndex}
                        text={t(subItem.name)}
                        onClick={() => {
                          history.push(subItem.route ? subItem.route : '#')
                          onMobileMenuClick({ isClosedDrawer: true, activeMenu: subItem })
                        }}
                        // popoverProps={{ isOpen: true }}
                      />
                    ))}
                  </MenuItem>
                ) : (
                  <MenuItem
                    key={`${item.name}${index}`}
                    icon={<i className={`fas ${item.icon} text-white`} />}
                    text={t(item.name)}
                    onClick={() => {
                      history.push(item.route ? item.route : '#')
                      onMobileMenuClick({ isClosedDrawer: true, activeMenu: item })
                    }}
                    // popoverProps={{ isOpen: true }}
                  />
                )}
              </Menu>
            </React.Fragment>
          ))
        : null}
    </div>
  )
}

export default BPMenuMobile
